const theme = {
  colors: {
    white: '#FFFFFF',
    background: '#FFFFFF',
    text: '#1F2937',
    green: {
      50: '#E7F6EC',
      100: '#CDEAD7',
      200: '#A1D8B6',
      300: '#74C694',
      400: '#4BB877',
      500: '#2E8B57',
      600: '#247047',
      700: '#1B5E20',
      800: '#164A16',
      900: '#0F3310'
    },
    orange: {
      50: '#FFF4E6',
      100: '#FFE4BF',
      200: '#FFD199',
      300: '#FFB266',
      400: '#FF9833',
      500: '#FF7F00',
      600: '#E56F00',
      700: '#CC6100',
      800: '#B35300',
      900: '#8C4100'
    },
    gray: {
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937'
    }
  },
  spacing: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px', xxl: '48px' },
  radii: { sm: '6px', md: '10px', lg: '14px', pill: '9999px' },
  shadows: {
    sm: '0 1px 2px rgba(0,0,0,0.06)',
    md: '0 4px 12px rgba(0,0,0,0.1)',
    lg: '0 10px 25px rgba(0,0,0,0.15)'
  },
  container: '1200px'
}

export default theme;
